import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import axios from "axios";

import ConsentForms from "../../components/Forms/ConsentForms/ConsentForms";
import Header from "../../components/UI/Header/Header";
import { backendBaseUri } from "../../uri";

import classes from "./formslist.css";

class FormsList extends Component {
    componentWillMount() {
        this.getConsentForms();
        this.props.clearForm();
    }

    getConsentForms() {
        axios
            .get(`${backendBaseUri}/forms`, {
                headers: {
                    "x-auth": localStorage.getItem("token"),
                },
            })
            .then((res) => {
                this.props.onFormListLoad(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    handleClickConsent(id) {
        axios
            .get(`${backendBaseUri}/forms/${id}`, {
                headers: {
                    "x-auth": localStorage.getItem("token"),
                },
            })
            .then((res) => {
                this.props.onDisplayForm(res.data.form);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    displayForms() {
        const { consentForms } = this.props;
        if (consentForms.forms) {
            return (
                <ConsentForms
                    forms={consentForms.forms}
                    handleClickConsent={this.handleClickConsent.bind(this)}
                />
            );
        } else {
            return <div>loading</div>;
        }
    }
    render() {
        return (
            <div>
                <header>
                    <Header />
                </header>
                <div className={classes.MainContainer}>
                    <div className={classes.ListSection}>
                        <h2>Consent Forms</h2>
                        {this.displayForms()}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        consentForms: state.formBuilder.consentForms,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onFormListLoad: (forms) => dispatch(actions.fetchForms(forms)),
        onDisplayForm: (form) => dispatch(actions.fetchForm(form)),
        clearForm: () => dispatch(actions.clearForm()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(FormsList);



// WEBPACK FOOTER //
// ./src/containers/FormsList/FormsList.js